module.exports = __webpack_public_path__ + "img/Nawab_Faizunnesa_House.01ecaa8d.png";